var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lastUpdate"},[_c('p',[_vm._v(_vm._s(_vm.txt.lastUpdate)+": "+_vm._s(_vm.lastUpdatedFormatted))])])
}
var staticRenderFns = []

export { render, staticRenderFns }